import { Outlet, useLocation } from "react-router-dom";
import { AppShell } from "@marekl/adminer/shell";
import { AdminerToaster } from "@marekl/adminer/components";
import { useAuth } from "../../auth/useAuth";
import { SessionExpiredModal } from "../../auth/SessionExpiredModal";
import { PersonDetailHost } from "../../components/PersonDetail";
import { Sidebar } from "../Sidebar";
import { ImpersonationBanner } from "../../components/ImpersonationBanner";
import { SeasonProvider } from "../../season";
import { SignedInNotices } from "../../components/Notices";
import { SHELL_CLASS } from "../shellMarker";

// Still its own component, but only to publish the outlet context: closing the
// drawer on navigation is AppShell's job now, via navigationKey.
function MainOutlet() {
  const location = useLocation();
  return <Outlet context={{ currentPath: location.pathname }} />;
}

export function AppLayout() {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return null;

  return (
    <SeasonProvider>
      <AppShell
        className={SHELL_CLASS}
        sidebar={<Sidebar user={user} />}
        navigationKey={location.pathname}
        toaster={<AdminerToaster position="bottom-right" toastOptions={{ duration: 4000 }} />}
      >
        {user.impersonator && <ImpersonationBanner user={user} />}
        <SignedInNotices />
        <MainOutlet />
        <SessionExpiredModal />
        <PersonDetailHost />
      </AppShell>
    </SeasonProvider>
  );
}
